var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Cofiza\n")])}
var staticRenderFns = []

export { render, staticRenderFns }